/* Logo de la cabecera (M38, revisado el 24-09-2026). Lo carga snippets/atelier-sep26-logo-mark.liquid.

   Al bajar, el nombre se desvanece y el símbolo se dibuja por grupos con la coreografía de After Effects de
   la web anterior (_ae_logo/tn_anim_spec.py: travesaño, N, C y rayo con golpe de escala). Al subir se
   deshace desde donde esté, sin reiniciar. Sigue el estado has-scrolled que pone atelier.js, el mismo que
   convierte la cabecera en cápsula (CSS en atelier-refinements.css).

   Con «Reducir movimiento» antes había un salto seco (1 ms). Desde el 24-09, por decisión de Adrian, el símbolo
   también se dibuja en su sitio (DRAW_WHEN_REDUCED): la cabecera no se desplaza ni cambia de forma, solo se traza
   el logo. Con DRAW_WHEN_REDUCED = false sería un fundido corto del nombre al símbolo completo, solo opacidad.
   «Reducir transparencia» no cambia nada del movimiento. */
(() => {
  if (window.__tnLogo) return;
  window.__tnLogo = true;

  /* Decisiones de Adrian: duración de la coreografía y si el símbolo se dibuja también con «Reducir movimiento». */
  const DUR = 766.7, FADE = 240, DRAW_WHEN_REDUCED = true;

  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const END = 46, STROKE = 1.1514;
  const TL = {
    '01_T_travesano': { trim: [0, 14], fill: [10, 18], sw: [14, 22] },
    '02_N_cuerpo': { trim: [5, 27], fill: [22, 32], sw: [27, 36] },
    '03_C_remate': { trim: [14, 30], fill: [26, 34], sw: [30, 38] },
    '04_rayo': { trim: [22, 34], fill: [30, 37], sw: [34, 41] }
  };
  const EZ = { draw: 'cubic-bezier(0.25, 0.1, 0.25, 1)', fill: 'cubic-bezier(0.4, 0, 0.4, 1)', stroke: 'cubic-bezier(0.4, 0, 0.6, 1)', punch: 'cubic-bezier(0.3, 0.9, 0.4, 1)', settle: 'cubic-bezier(0.45, 0, 0.25, 1)', wordmark: 'cubic-bezier(0.55, 0, 0.85, 0.35)' };
  const PUNCH = [[30, 0.7], [37, 1.13], [44, 1]], SETTLE = [[0, 0.97], [46, 1]];
  const two = (prop, f0, f1, v0, v1, ease) => {
    const o0 = f0 / END, o1 = f1 / END, ks = [];
    ks.push({ offset: 0, easing: o0 > 0 ? 'linear' : ease, [prop]: v0 });
    if (o0 > 0) ks.push({ offset: o0, easing: ease, [prop]: v0 });
    ks.push({ offset: o1, easing: 'linear', [prop]: v1 });
    if (o1 < 1) ks.push({ offset: 1, [prop]: v1 });
    return ks;
  };
  const many = (prop, keys, ease) => {
    const ks = [];
    if (keys[0][0] > 0) ks.push({ offset: 0, easing: ease, [prop]: `scale(${keys[0][1]})` });
    keys.forEach(([f, v]) => ks.push({ offset: f / END, easing: ease, [prop]: `scale(${v})` }));
    if (keys[keys.length - 1][0] < END) ks.push({ offset: 1, [prop]: `scale(${keys[keys.length - 1][1]})` });
    return ks;
  };
  const compact = () => document.body.classList.contains('has-scrolled');
  let anims = [], dur = DUR, dir = 0;

  function build() {
    anims.forEach(a => a.cancel());
    anims = [];
    const root = document.documentElement;
    const link = document.querySelector('.site-header .wordmark');
    const svg = link && link.querySelector('.sep26-mark');
    const wordmark = link && link.querySelector(':scope > img');
    if (!svg || typeof svg.animate !== 'function') { root.classList.remove('sep26-logo-waapi', 'sep26-logo-fade'); return; }
    const fade = reduced.matches && !DRAW_WHEN_REDUCED;
    dur = fade ? FADE : DUR;
    const add = (el, ks, easing = 'linear') => {
      if (!el) return;
      const a = el.animate(ks, { duration: dur, fill: 'both', easing });
      a.pause(); a.currentTime = 0; anims.push(a);
    };
    root.classList.add('sep26-logo-waapi');
    root.classList.toggle('sep26-logo-fade', fade);
    if (fade) {
      /* Relevo, no doble exposición: el nombre se va en la primera mitad y el símbolo entra en la segunda. */
      add(svg, [{ offset: 0, opacity: 0 }, { offset: 0.35, opacity: 0, easing: 'ease-out' }, { offset: 1, opacity: 1 }]);
      if (wordmark) add(wordmark, [{ offset: 0, opacity: 1, easing: 'ease-in' }, { offset: 0.55, opacity: 0 }, { offset: 1, opacity: 0 }]);
    } else {
      svg.querySelectorAll('.tn-g').forEach(g => {
        const t = TL[g.dataset.g];
        if (!t) return;
        g.querySelectorAll('path').forEach(p => {
          add(p, two('strokeDashoffset', t.trim[0], t.trim[1], 1, 0, EZ.draw));
          add(p, two('fillOpacity', t.fill[0], t.fill[1], 0, 1, EZ.fill));
          add(p, two('strokeWidth', t.sw[0], t.sw[1], STROKE, 0, EZ.stroke));
        });
      });
      add(svg.querySelector('.tn-bolt'), many('transform', PUNCH, EZ.punch));
      add(svg.querySelector('.tn-root'), many('transform', SETTLE, EZ.settle));
      if (wordmark) {
        add(wordmark, two('opacity', 0, 7, 1, 0, EZ.wordmark));
        add(wordmark, two('transform', 0, 7, 'scale(1)', 'scale(0.96)', EZ.wordmark));
      }
    }
    dir = compact() ? 1 : -1;
    if (dir > 0) anims.forEach(a => { a.currentTime = dur; });
  }

  /* Hacia delante o hacia atrás desde donde esté: sin reinicio ni temporizadores si el scroll cambia de sentido. */
  function setDir(next) {
    if (next === dir) return;
    dir = next;
    anims.forEach(a => {
      const t = a.currentTime || 0;
      if (dir < 0 && t <= 0) { a.pause(); a.currentTime = 0; return; }
      if (dir > 0 && t >= dur) { a.pause(); a.currentTime = dur; return; }
      a.playbackRate = dir; a.play();
    });
  }

  function start() {
    build();
    new MutationObserver(() => setDir(compact() ? 1 : -1)).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    reduced.addEventListener('change', build);
    document.addEventListener('shopify:section:load', event => { if (event.target.querySelector('.wordmark')) build(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();
